<template>
  <div class="content bg8">
      <div class="explore-programs-dropdown" style="text-align:center;padding:24px 16px 18px 16px;background:#fff;border-radius:12px;box-shadow:0 2px 8px 0 rgba(191,0,255,0.04);">
        <label for="program-select" class="dropdown-label" style="font-weight:600;color:#7a4fa3;font-size:1.1rem;margin-bottom:10px;display:block;">Explore Internship Programs</label>
        <select id="program-select" class="program-select" @change="onProgramChange" :value="$route.path">
          <option value="/digital-marketing-internship">Digital Marketing</option>
          <option value="/social-media-marketing-internship">Social Media Marketing</option>
          <option value="/content-creation-internship">Content Creation and Copywriting</option>
          <option value="/website-design-internship">Website Design</option>
          <option value="/data-analytics-internship">Data Analytics and BI</option>
          <option value="/graphic-design-internship">Graphic Design</option>
        </select>
      </div>
      <div class="middled">
        <div class="button-row">
          <a href="https://forms.gle/sgqWzHuRMRCzCV6q6" target="_blank" rel="nofollow">
            <button class="wide" style="background: #fff; color: #BF00FF; border: 1px solid #BF00FF;">Company Application</button>
          </a>
          <a href="https://forms.gle/gv7FWmgVsKKPBfhX7" target="_blank" rel="nofollow">
            <button class="wide" style="background: #fff; color: #BF00FF; border: 1px solid #BF00FF;">Intern Application</button>
          </a>
        </div>
      <div class="basehero">
        <h1>Graphic Design Internship Program</h1>
        <h2 class="section">Design That Makes an Impact</h2>

        <p>
          <strong>Foclarity’s Graphic Design Internship Program</strong> matches startups with creative, ambitious student designers eager to bring brands to life. Interns get hands-on experience across real-world projects—logos, marketing assets, UI, and more—while startups receive high-quality design that tells their story and drives engagement.
        </p>

        <h3>For Startups:</h3>
        <p>
          Need a fresh visual identity or polished assets to support your growth? Our design interns help you look as good as you are—with work guided by professional standards.
        </p>
        <ul>
          <li>Custom logo design and brand identity development</li>
          <li>Marketing materials (brochures, flyers, one-pagers, business cards)</li>
          <li>Social media graphics and ad creatives</li>
          <li>Website layout, UI mockups, and user-centered design</li>
          <li>Investor-ready pitch decks and presentations</li>
        </ul>
        <p>
          We handle the design team and quality assurance—so you can focus on growing your business while looking great doing it.
        </p>

        <h3>For Interns:</h3>
        <p>
          Bring your creativity to life in real projects with real clients. You’ll get the chance to design across multiple formats and industries, while building a professional portfolio that opens doors.
        </p>
        <ul>
          <li>Hands-on experience with Adobe Creative Suite, Figma, Canva, and more</li>
          <li>Projects ranging from logos to full brand systems</li>
          <li>Opportunities to design websites, social content, and marketing collateral</li>
          <li>Feedback and mentorship from experienced design professionals</li>
          <li>A portfolio of real-world work with measurable impact</li>
        </ul>
        <p>
          You won’t just practice design—you’ll contribute to the growth of real startups.
        </p>

        <h3>Ready to Design Your Future?</h3>
        <p>
          If you’re a founder who needs professional visuals or a student ready to build a real design portfolio, this program is for you.
        </p>

        <div class="button-row">
          <a href="https://forms.gle/sgqWzHuRMRCzCV6q6" target="_blank" rel="nofollow">
            <button class="wide" style="background: #fff; color: #BF00FF; border: 1px solid #BF00FF;">Company Application</button>
          </a>
          <a href="https://forms.gle/gv7FWmgVsKKPBfhX7" target="_blank" rel="nofollow">
            <button class="wide" style="background: #fff; color: #BF00FF; border: 1px solid #BF00FF;">Intern Application</button>
          </a>
        </div>
      </div>
      <div class="explore-programs" style="text-align:center;padding:32px 16px 24px 16px;background:#f7f2fa;border-radius:12px;box-shadow:0 2px 8px 0 rgba(191,0,255,0.04);">
        <h2 style="color:#7a4fa3;font-size:1.3rem;margin-bottom:16px;">Explore More Internship Programs</h2>
        <ul class="explore-list" style="list-style:none;padding:0;margin:0;">
          <li style="margin:10px 0;"><router-link to="/digital-marketing-internship" class="subnav-link">Digital Marketing</router-link></li>
          <li style="margin:10px 0;"><router-link to="/social-media-marketing-internship" class="subnav-link">Social Media Marketing</router-link></li>
          <li style="margin:10px 0;"><router-link to="/content-creation-internship" class="subnav-link">Content Creation and Copywriting</router-link></li>
          <li style="margin:10px 0;"><router-link to="/website-design-internship" class="subnav-link">Website Design</router-link></li>
          <li style="margin:10px 0;"><router-link to="/data-analytics-internship" class="subnav-link">Data Analytics and BI</router-link></li>
          <li style="margin:10px 0;"><router-link to="/graphic-design-internship" class="subnav-link">Graphic Design</router-link></li>
        </ul>
        <div style="margin-top:18px;">
          <router-link to="/who-we-serve" class="subnav-link" style="font-size:1.05em;">Back to All Programs</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GraphicDesignInternship",
  methods: {
    onProgramChange(event) {
      const path = event.target.value;
      if (path && path !== this.$route.path) {
        this.$router.push(path);
      }
    }
  }
};
</script>

<style scoped>
.subnav-link {
  margin: 0 10px;
  color: #BF00FF;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
}
.subnav-link:hover {
  color: #7a4fa3;
  text-decoration: underline;
}
.subnav-link.router-link-exact-active {
  text-decoration: underline;
  font-weight: bold;
}
.explore-programs-dropdown {
  margin: 40px auto 0 auto;
  max-width: 600px;
  text-align: center;
  padding: 24px 16px 18px 16px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px 0 rgba(191,0,255,0.04);
}
.dropdown-label {
  font-weight: 600;
  color: #7a4fa3;
  font-size: 1.1rem;
  margin-bottom: 10px;
  display: block;
}
.program-select {
  width: 100%;
  max-width: 420px;
  padding: 12px 16px;
  font-size: 1.08rem;
  border: 1.5px solid #BF00FF;
  border-radius: 8px;
  background: #f7f2fa;
  color: #41037b;
  font-weight: 500;
  outline: none;
  transition: border 0.2s;
  margin: 0 auto;
  box-shadow: 0 1px 4px 0 rgba(122,79,163,0.04);
}
.program-select:focus {
  border: 2px solid #7a4fa3;
}
@media (max-width: 600px) {
  .explore-programs-dropdown {
    padding: 16px 4px 12px 4px;
  }
  .program-select {
    font-size: 1em;
    padding: 10px 8px;
    max-width: 100%;
  }
}
</style>
